<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-dialog v-model="confirm_dialog" persistent max-width="400px">
    <v-card flat class="pa-4">
      <v-card-text>
        <div align="center" justify="center">
          <v-progress-circular
            :size="70"
            :width="1"
            :value="100"
            color="red"
            class="ma-4 mt-2"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
        <h5 class="grey--text text-center font-weight-normal">Please confirm you want to run Day-End on or upto: {{DatesObject.EndDate}}</h5>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn class="white--text" small color="#2A353D" @click="confirm_dialog = false">cancel</v-btn>
          <v-btn class="white--text ml-4" small color="#2A353D" @click="Running = true; run(); confirm_dialog = false">
            <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
            OK
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat >
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Period End</v-toolbar-title>
    <v-spacer/>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-card>
    <div class="pa-5 text-center">
      <v-progress-circular
        class="my-7"
        :size="250"
        :width="5"
        :indeterminate="Running"
        :value="complete? 100 : 0"
        color="#2A353D"
      >
        <v-icon v-if="!complete && !error" x-large>mdi-calendar-multiple</v-icon>
        <v-icon v-if="!error && complete" color="#2A353D" x-large>mdi-check</v-icon>
        <v-icon v-if="!complete && error" color="red" x-large>mdi-exclamation-thick</v-icon>
      </v-progress-circular>
      <p class="red--text" v-if="!complete && error">{{message}}</p>
    </div>

    <div class="pb-10 text-center">
      <v-row class="mx-12 px-12">
        <v-col class="pb-0 pt-0">
          <v-text-field
            :value="currentSystemDate.DayDate"
            label="Current Date"
            append-icon="mdi-calendar-month"
            readonly placeholder="--/--/--"
            dense outlined color="#2A353D"
            :rules="TextFieldRules"
          ></v-text-field>
        </v-col>
        <v-col class="pb-0 pt-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="DatesObject.EndDate"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="DatesObject.EndDate"
              label="End Date"
              append-icon="mdi-calendar-month"
              readonly placeholder="--/--/--"
              dense outlined color="#2A353D"
              hint="Day-End will be run on or upto this date"
              persistent-hint
              :rules="DateRules"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker :readonly="view" color="#2A353D" v-model="DatesObject.EndDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
            <v-btn outlined small color="#2A353D" @click="$refs.menu.save(DatesObject.EndDate)">OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </div>

    <div class="pb-10 text-center">
      <v-btn color="#2A353D" outlined :disabled="Running == true || error == true" @click="confirm_dialog = true">
        RUN PERIOD END
      </v-btn>
    </div>
  </v-card>
</v-container>
</template>

<script>
import {mapGetters} from "vuex";
import UserService from '../services/user.service';
import toolsService from '../services/tools.service';

export default {

  data () {
    return {
      temp: '',
      permitted: null,
      permitted_dialog: true,
      confirm_dialog: false,
      Running: false,
      complete: false,
      error: false,
      message: '',
      search: '',
      valid: true,
      menu: false,
      content: '',
      DatesObject: {
        CurrentDate: null,
        EndDate: null
      },
      headers: [
        {
          text: 'Function',
          align: 'start',
          sortable: true,
          value: 'FunctionID'
        },
        { text: 'Is Confirmation Required', value: 'Status', sortable: false },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      DateRules: [
        v => !!v || 'field is required',
        v => (v >= this.currentSystemDate.DayDate) || 'Date cannot be before System Date'
      ],
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allPermissions",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings",
      "currentSystemDate",
      ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 701).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 701).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 701).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 701).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },
  },

  created(){
    this.DatesObject.EndDate = this.currentSystemDate.DayDate
  },

  methods: {

    async run() {
      this.message = '';
      this.DatesObject.CurrentDate = this.currentSystemDate.DayDate

      await this.$socket.client.emit('socketlogoutreq');

      toolsService.runPeriodEnd(this.DatesObject)
      .then(response => {
        this.temp = response.data;
        this.message = response.data[0].peResultMsg;
        this.Running = false;
        this.$store.dispatch('getSystemDate');
        if(response.data[0].peResultMsg.includes("Day end completed successfully")){
          this.complete = true;
        } else {
          this.error = true;
        }
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.Running = false;
        this.error = true;
      })
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    setActiveBankAccountType (item, index) {
      this.currentBankAccountType = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isPeriodEnd().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
